/**
 * API
 * @author David <david.prenninger@gmx.de>
 *
 * This file provides all helper functions related to http calls.
 */
import {
  HOST_SITE,
  PAGE_LOCAL,
  SERVER_ADDRESS,
  WOOCOMMERCE_API_ADRESS,
  WC_CUSTOMER_SECRET,
  WC_CUSTOMER_KEY,
  PAGE_AREA,
} from '../constants';

export const generatePDF = (order) => fetch(`${SERVER_ADDRESS}/pdf`, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ data: order }),
}).then((response) => response.json());

export const sendContact = (files, order) => {
  const formData = new FormData();
  files.forEach((file, index) => formData.set(`file-${index}`, file));
  formData.set('data', JSON.stringify(order));
  return fetch(`${SERVER_ADDRESS}/mail`, {
    method: 'POST',
    body: formData,
  }).then((response) => response.json());
};

export const getOfferID = () => fetch(`${SERVER_ADDRESS}/offer`)
  .then((response) => response.json());


const getNumberAttribute = (base, attributeName) => {
  const attribute = base.attributes.find((atb) => atb.name === attributeName);
  return attribute ? Number(attribute.options[0]) : attribute;
};

const getBooleanAttribute = (base, attributeName) => {
  const attribute = base.attributes.find((atb) => atb.name === attributeName);
  return attribute ? Boolean(attribute.options[0]) : attribute;
};

const getTextAttribute = (base, attributeName) => {
  const attribute = base.attributes.find((atb) => atb.name === attributeName);
  return attribute ? attribute.options[0] : attribute;
};

/**
 * Loads Products from woocommerce and pushes them into the store.
 * @param vue The current vue Instance.
 * @return void
 */
export const getProductData = async (vue) => {
  const data = await fetch(`${WOOCOMMERCE_API_ADRESS}/products?consumer_key=${WC_CUSTOMER_KEY}&consumer_secret=${WC_CUSTOMER_SECRET}&per_page=100`, {
    credentials: 'omit',
  })
    .then((response) => response.json());

  data.forEach((product) => {
    const width = getNumberAttribute(product, 'width');
    const length = getNumberAttribute(product, 'length');
    const type = getTextAttribute(product, 'type');
    const cutout = getBooleanAttribute(product, 'cutout');
    const angle = getNumberAttribute(product, 'angle');
    const model = getTextAttribute(product, 'model');

    const size = getNumberAttribute(product, 'size');
    const image = getTextAttribute(product, 'image');
    const isEnd = getBooleanAttribute(product, 'isEnd');
    const isInline = getBooleanAttribute(product, 'isInline');

    // Attributes for stands
    const isClampApproved = getBooleanAttribute(product, 'isClampApproved');

    // Attributes for Clamps
    const maxExtension = getNumberAttribute(product, 'maxExtension');
    const minExtension = getNumberAttribute(product, 'minExtension');
    const modelB = getTextAttribute(product, 'modelB');

    const sliceTextLocal = (text, local) => {
      let out = '';
      if (text.indexOf(`[:${local}]`) !== -1) {
        out = text.substring(
          text.indexOf(`[:${local}]`) + 5,
          text.length,
        );
      }

      if (out === '' || text.indexOf(`[:${local}]`) === -1) {
        if (text.indexOf('[:en]') === -1) {
          out = text;
        } else {
          out = text.substring(
            text.indexOf('[:en]') + 5,
            text.length,
          );
        }
      }
      if (out.indexOf('[:') !== -1) {
        out = out.substring(
          0,
          out.indexOf('[:'),
        );
      }
      // Remove Paragraph wrapping if needed.
      out = out.replace('<p>', '').replace('</p>', '');
      return out;
    };

    // Setting the product title
    // If a language tag exists it will be used to spit up the string.
    const title = sliceTextLocal(product.name, vue.$i18n.locale);
    const description = sliceTextLocal(product.description, vue.$i18n.locale);

    const object = {
      id: product.id,
      title,
      description,
      width,
      length,
      type,
      cutout,
      size,
      image,
      isEnd,
      isInline,
      isClampApproved,
      maxExtension,
      minExtension,
      link: product.permalink,
      modelB,
      angle,
      price: Number(product.price),
      altPrice: 0,
      model,
    };

    // Remove all undefined keys
    Object.keys(object).forEach((key) => {
      if (object[key] === undefined) {
        delete object[key];
      }
    });
    vue.$store.dispatch('addProduct', object);
  });
};

export const addToCart = (products) => {
  const addItemsToCart = async () => {
    for (let n = 0; n < products.length; n += 1) {
      const product = products[n];
      let localUrlExtension = `${PAGE_LOCAL}/`;
      console.log(PAGE_AREA);
      if (PAGE_AREA !== 'DE') {
        localUrlExtension = '';
      }
      await fetch( // eslint-disable-line no-await-in-loop
        `${HOST_SITE}/${localUrlExtension}wp-json/cocart/v1/add-item`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            product_id: `${product.id}`,
            quantity: parseFloat(product.quantity),
          }),
        },
      );
    }
  };
  addItemsToCart().then(() => {
    window.location.replace(`${HOST_SITE}/${PAGE_LOCAL}/warenkorb/`);
  });
};
